import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Divider, Form, message, Modal, Spin } from "antd";
import { CardContainer } from "../../components/Card/CardContainer";
import { useRecoilValue, useSetRecoilState } from "recoil";
import Button from "../../components/Button/Button";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import { PromotionCreateStep1 } from "./createPromotionStep/PromotionCreateStep1";
import { PromotionCreateStep2 } from "./createPromotionStep/PromotionCreateStep2";
import { PromotionCreateStep3 } from "./createPromotionStep/PromotionCreateStep3";
import {
  PROMOTION_TYPE_NAME,
  PromotionGroup,
  PromotionGroupOption,
  PromotionType,
} from "../../definitions/promotion";
import productState from "../../store/productList";
import { ProductEntity } from "../../entities/PoductEntity";
import {
  createPromotion,
  getPromotionById,
  updatePromotion,
  updatePromotionFile,
} from "../../datasource/PromotionDatasource";
import { FlexCol } from "../../components/Container/Container";
import { CheckCircleTwoTone } from "@ant-design/icons";
import color from "../../resource/color";
import Text from "../../components/Text/Text";
import { useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import promotionState from "../../store/promotion";
import { PromotionConditionGroupEntity } from "../../entities/PromotionSettingEntity";
import StepAntd from "../../components/StepAntd/StepAntd";
import { getProductList } from "../../datasource/ProductDatasource";

export const PromotionCreatePage: React.FC = () => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company, firstname, lastname } = userProfile;

  const navigate = useNavigate();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const isEditing = pathSplit[3] === "edit";
  const [searchParams, setSearchParams] = useSearchParams();
  const { copyId } = useMemo(() => {
    return { copyId: searchParams.get("copy_id") };
  }, [searchParams]);

  const productList = useRecoilValue(productState);
  const setProductList = useSetRecoilState(productState);
  const promoStateValue = useRecoilValue(promotionState);
  const setPromoState = useSetRecoilState(promotionState);

  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();

  const [step, setStep] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [promotionData, setPromotionData] = useState<any>({
    promotionType: undefined,
    stores: undefined,
    items: undefined,
  });
  const [defaultData, setDefaultData] = useState<any>();
  const [showStep2Error, setStep2Error] = useState(false);

  const [isCreating, setCreating] = useState(false);
  const [isDone, setDone] = useState(false);

  const [file1, _setFile1] = useState<any>();
  const [file2, _setFile2] = useState<any>();
  const [fileMemo, _setFileMemo] = useState<any>();
  const [imageUrl1, _setImgUrl1] = useState<string>();
  const [imageUrl2, _setImgUrl2] = useState<string>();
  const [fileMemoUrl, _setFileMemoUrl] = useState<any>();
  const [fileEditHistory, setFileEditHistoy] = useState(new Set());
  const [creditValue, setCreditValue] = useState<string | undefined>(undefined);
  const [creditType, setCreditType] = useState<string | undefined>(undefined);
  const [imgPromotion, setImgPromotion] = useState<boolean>(false);

  const fileKeys = {
    IMAGE1: "img1",
    IMAGE2: "img2",
    MEMO: "memo",
  };
  const addFileEditHistory = (s: string) => {
    const set = new Set(fileEditHistory);
    set.add(s);
    setFileEditHistoy(set);
  };
  const setFileMemo = (file: any) => {
    _setFileMemo(file);
    addFileEditHistory(fileKeys.MEMO);
  };
  const setFileMemoUrl = (file: any) => {
    _setFileMemoUrl(file);
    addFileEditHistory(fileKeys.MEMO);
  };

  useEffect(() => {
    if ((isEditing || copyId) && !loading) fetchPromotion();
  }, []);

  const fetchPromotion = async () => {
    setLoading(true);
    const id = isEditing || !copyId ? pathSplit[4] : copyId;
    await getPromotionById(id)
      .then((res) => {
        if (copyId) {
          res.promotionCode = res.promotionCode + "_copy";
          res.promotionName = res.promotionName + " (copy)";
          res.startDate = null;
          res.endDate = null;
          res.quotaUsed = undefined;
          res.quotaBalance = undefined;
          res.promotionShop = res.promotionShop.map((s) => ({
            ...s,
            quotaReceive: undefined,
            quotaUsed: undefined,
            quotaBalance: undefined,
          }));
        }
        setDefaultData(res);
        let promotionGroupOption;
        if (res?.conditionDetail) {
          if (res.promotionType === PromotionType.DISCOUNT_MIX) {
            promotionGroupOption = res.conditionDetail[0]?.conditionDiscount?.typeMix;
          } else if (res.promotionType === PromotionType.FREEBIES_MIX) {
            promotionGroupOption = res.conditionDetail[0]?.typeMix;
          }
        }
        setPromoState({ ...promoStateValue, promotion: res, promotionGroupOption });
        if (res.promotionImageFirst) {
          _setImgUrl1(res.promotionImageFirst);
        }
        if (res.promotionImageSecond) {
          _setImgUrl2(res.promotionImageSecond);
        }
        if (res.fileMemoPath) {
          _setFileMemoUrl(res.fileMemoPath);
        }
        if (res.creditTermValue) {
          setCreditValue(res.creditTermValue);
        }
        if (res.creditTermType) {
          setCreditType(res.creditTermType);
        }
        form1.setFieldsValue({
          ...res,
          creditTermType: res.creditTermType,
          creditTermValue:
            res.creditTermType === "NONE"
              ? null
              : res.creditTermType === "DAY"
                ? res.creditTermValue
                : dayjs(res.creditTermValue),
          startDate: copyId ? undefined : dayjs(res.startDate),
          endDate: copyId ? undefined : dayjs(res.endDate),
          startTime: copyId ? dayjs("0000-00-00 00:00") : dayjs(res.startDate),
          endTime: copyId ? dayjs("0000-00-00 23:59") : dayjs(res.endDate),
          referencePromotion: res.referencePromotion ? res.referencePromotion : [],
          memoFile: res.fileMemoPath
            ? [
                {
                  uid: "-1",
                  name: "file1.pdf",
                  status: "done",
                  url: fileMemoUrl,
                },
              ]
            : undefined,
          firstDateNoti: copyId
            ? undefined
            : res.notiFirstDate
              ? dayjs(res.notiFirstDate)
              : undefined,
          notiSecondDate: copyId ? undefined : dayjs(res.notiSecondDate),
          firstTimeNoti: copyId
            ? dayjs("0000-00-00 07:00")
            : res.notiFirstDate
              ? dayjs(res.notiFirstDate)
              : dayjs("0000-00-00 07:00"),
          secondTimeNoti: copyId
            ? dayjs("0000-00-00 07:00")
            : res.notiSecondDate
              ? dayjs(res.notiSecondDate)
              : dayjs("0000-00-00 07:00"),
          isShowPromotion: res.isShowPromotion,
        });
        form2.setFieldsValue({
          stores: res.promotionShop,
          isQuotaShop: res.isQuotaShop,
        });
        if (PromotionGroup.MIX.includes(res.promotionType)) {
          let newList: ProductEntity[] = [];
          let newGroupKeys: number[] = [];
          const conditionDetail: PromotionConditionGroupEntity[] = res?.conditionDetail;
          conditionDetail?.forEach(({ products, conditionDiscount, conditionFreebies }, i) => {
            if (res.promotionType !== "OTHER") {
              const getType =
                res?.conditionDetail[i].typeMix ||
                res?.conditionDetail[i].conditionDiscount.typeMix ||
                "";
              if (getType === PromotionGroupOption.UNIT) {
                const groupKey = i + 1;
                const nextList = products?.map((p) => (p.groupKey ? p : { ...p, groupKey })) || [];
                newList = [...newList, ...nextList];
                newGroupKeys = [...newGroupKeys, groupKey];
              } else {
                const groupKey = i + 1;
                const nextList = products?.map((p) => (p.groupKey ? p : { ...p, groupKey })) || [];
                newList = [...newList, ...nextList];
                if (conditionDiscount) {
                  newList = newList.map((x) => {
                    const findDiscountPrice = conditionDiscount.products.find(
                      (y: any) => y.productId === x.productId,
                    );
                    if (findDiscountPrice) {
                      return {
                        ...x,
                        discountPrice: findDiscountPrice.discountPrice,
                        size: res?.conditionDetail[i].conditionDiscount.size,
                        min: res?.conditionDetail[i].conditionDiscount.min,
                        max: res?.conditionDetail[i].conditionDiscount.max,
                      };
                    } else {
                      return { ...x };
                    }
                  });
                } else {
                  newList = newList.map((x) => {
                    return { ...x, size: res?.conditionDetail[i].size };
                  });
                }
                newGroupKeys = [...newGroupKeys, groupKey];
              }
            } else {
              const groupKey = i + 1;
              const nextList = products?.map((p) => (p.groupKey ? p : { ...p, groupKey })) || [];
              newList = [...newList, ...nextList];
              newGroupKeys = [...newGroupKeys, groupKey];
            }
          });
          form3.setFieldValue("items", newList);
        } else if (res.promotionType === PromotionType.DISCOUNT_NOT_MIX_SET) {
          form3.setFieldValue(
            "items",
            res.conditionDetail?.map((c) => ({ ...c, ...c?.condition })),
          );
        } else {
          form3.setFieldValue("items", res.conditionDetail);
        }
        (res.conditionDetail as any[])?.forEach((p: any, i: number) => {
          if (PromotionGroup.MIX.includes(res?.promotionType)) {
            form3.setFieldValue(
              `${i + 1}`,
              p.conditionFreebies || p.conditionDiscount || [{ detail: p.detail }] || [],
            );
          } else {
            form3.setFieldValue(`promotion-${p.productId}`, p.condition || []);
          }
        });
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchProductList = async () => {
    const { data } = await getProductList({
      company,
      take: 1000,
    });
    setProductList({
      ...productList,
      allData: data,
    });
    return data;
  };

  const PageTitle = () => {
    return (
      <PageTitleNested
        title={isEditing ? "แก้ไขโปรโมชัน" : "เพิ่มโปรโมชัน"}
        showBack
        extra={
          <StepAntd
            current={step}
            items={[
              {
                title: "ข้อมูลเบื้องต้น",
              },
              {
                title: (
                  <>
                    เลือกเขต
                    <br />
                    และร้านค้า
                  </>
                ),
              },
              {
                title: (
                  <>
                    รายละเอียด
                    <br />
                    โปรโมชัน
                  </>
                ),
              },
            ]}
          />
        }
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "รายการโปรโมชัน", path: -1 },
              {
                text: isEditing ? "แก้ไขโปรโมชัน" : "เพิ่มโปรโมชัน",
                path: window.location.pathname,
              },
            ]}
          />
        }
      />
    );
  };

  const stepsComponents = [
    <PromotionCreateStep1
      form={form1}
      fileMemo={fileMemo}
      setFileMemo={setFileMemo}
      fileMemoUrl={fileMemoUrl}
      setFileMemoUrl={setFileMemoUrl}
      isEditing={isEditing}
      isCopying={!!copyId}
      key={0}
      creditTermType={creditType}
      imgPromotion={imgPromotion}
      setImgPromotion={setImgPromotion}
      quotaUsed={defaultData?.quotaUsed || 0}
      form3={form3}
    />,
    <PromotionCreateStep2
      form={form2}
      showError={showStep2Error}
      setError={setStep2Error}
      totalQuota={form1.getFieldValue("promotionQuota")}
      promotionType={form1.getFieldValue("promotionType")}
      key={1}
    />,
    <PromotionCreateStep3
      form={form3}
      promotionType={form1.getFieldValue("promotionType")}
      isEditing={isEditing}
      isCopying={!!copyId}
      key={2}
      company={company}
    />,
  ];

  const onNext = async () => {
    if (step === 0) {
      form1
        .validateFields()
        .then((values) => {
          setPromotionData({
            ...promotionData,
            ...values,
          });
          setStep(step + 1);
        })
        .catch((errInfo) => {
          console.log("errInfo", errInfo);
        });
    } else if (step === 1) {
      const isQuotaShop = form2.getFieldValue("isQuotaShop");
      form2
        .validateFields()
        .then(() => {
          const stores = form2.getFieldValue("stores");
          if (!stores || stores.length <= 0) {
            setStep2Error(true);
          } else if (
            isQuotaShop &&
            stores.find(
              (s) => !s.quotaReceive || parseFloat(s.quotaUsed) > parseFloat(s.quotaReceive),
            )
          ) {
            setStep2Error(true);
          } else {
            setPromotionData({
              ...promotionData,
              isQuotaShop,
              stores,
            });
            setStep(step + 1);
          }
        })
        .catch((errInfo) => {
          console.log("errInfo", errInfo);
        });
    } else if (step === 2) {
      form3
        .validateFields()
        .then((values) => {
          const promoList = form3.getFieldsValue();
          if (
            promotionData.promotionType === PromotionType.FREEBIES_NOT_MIX ||
            promotionData.promotionType === PromotionType.FREEBIES_MIX
          ) {
            if (!Object.entries(promoList).length) {
              Modal.error({
                title: "กรุณาระบุรายละเอียดโปรโมชัน",
              });
              return;
            }
            const pass = Object.entries(promoList).every(([key, value]) => {
              if (
                promotionData.promotionType === PromotionType.FREEBIES_MIX &&
                key.split("-")[1] === "weight"
              ) {
                return true;
              }
              return (value as any[]).every(
                (val: any) =>
                  val?.freebies &&
                  val?.freebies?.length > 0 &&
                  (val?.freebies as any[]).every(
                    (freebie: any) => freebie?.quantity && freebie?.quantity > 0,
                  ),
              );
            });
            if (!pass) {
              Modal.error({
                title: "กรุณาระบุจำนวนของแถมให้ครบถ้วน",
              });
              return;
            }
          }
          if (
            promotionData.promotionType === PromotionType.DISCOUNT_NOT_MIX_SET &&
            Object.entries(promoList).length <= 1
          ) {
            Modal.error({
              title: `โปรโมชันแบบ '${
                PROMOTION_TYPE_NAME[PromotionType.DISCOUNT_NOT_MIX_SET]
              }' ต้องมีสินค้าในโปรโมชันมากกว่า 1 ชิ้น`,
            });
            return;
          }
          const data = {
            ...promotionData,
            items: form3.getFieldsValue(),
          };
          onSubmit(false, data);
          setPromotionData(data);
        })
        .catch((errInfo) => {
          console.log("errInfo", errInfo, form3.getFieldsValue());
        });
    }
  };

  const onSaveDraft = async () => {
    const data = {
      ...promotionData,
      ...form1.getFieldsValue(),
      stores: form2.getFieldValue("stores"),
      items: form3.getFieldsValue(),
    };
    setPromotionData(data);
    onSubmit(false, data);
  };

  const onSubmit = async (promotionStatus: boolean, promotionData: any) => {
    setCreating(true);
    const {
      promotionType,
      items,
      stores,
      startDate,
      endDate,
      startTime,
      endTime,
      firstDateNoti,
      firstTimeNoti,
      secondTimeNoti,
      quota,
      creditTermType,
      creditTermValue,
    } = promotionData;
    const id = isEditing ? pathSplit[4] : undefined;

    const submitData = {
      ...promotionData,
      promotionId: id,
      promotionStatus,
      isDraft: promotionStatus,
      company,
      stores: undefined,
      items: undefined,
      memoFile: undefined,
      horizontalImage: undefined,
      verticalImage: undefined,
      promotionShop: stores,
      conditionDetailDiscount: undefined,
      conditionDetailFreebies: undefined,
      creditTermType: creditTermType,
      creditTermValue:
        creditTermType === "NONE"
          ? null
          : creditTermType === "DAY"
            ? creditTermValue
            : dayjs(creditTermValue).toISOString(),
      startDate:
        startDate && startTime
          ? dayjs(
              `${startDate.format("YYYY-MM-DD")} ${startTime.format("HH:mm")}:00.000`,
            ).toISOString()
          : undefined,
      endDate:
        endDate && endTime
          ? dayjs(`${endDate.format("YYYY-MM-DD")} ${endTime.format("HH:mm")}:00.000`).toISOString()
          : undefined,
      startTime: undefined,
      endTime: undefined,
      notiFirstDate:
        firstDateNoti && firstTimeNoti
          ? dayjs(
              `${firstDateNoti.format("YYYY-MM-DD")} ${firstTimeNoti.format("HH:mm")}:00.000`,
            ).toISOString()
          : undefined,
      notiSecondDate:
        startDate && secondTimeNoti
          ? dayjs(
              `${startDate.format("YYYY-MM-DD")} ${secondTimeNoti.format("HH:mm")}:00.000`,
            ).toISOString()
          : undefined,
      createBy: isEditing ? undefined : `${firstname} ${lastname}`,
      updateBy: isEditing ? `${firstname} ${lastname}` : undefined,
      isQuotaAll: quota && quota > 0,
    };
    const promoList = form3.getFieldsValue();

    if (promotionType === PromotionType.FREEBIES_NOT_MIX) {
      let productListData = productList?.allData || [];
      if (!productList?.allData?.length) {
        productListData = await fetchProductList();
      }
      submitData.conditionDetailDiscount = undefined;
      submitData.conditionDetailFreebies = Object.entries(promoList).map(([key, value]: any[]) => {
        const [pKey, productId] = key.split("-");
        const { productName, productCategory, productImage, packSize } =
          productListData?.find((p: ProductEntity) => `${p.productId}` === `${productId}`) ||
          ({} as ProductEntity);
        const condition = value.map((v: any) => {
          const quantity = !Number.isInteger(parseFloat(v.quantity))
            ? parseFloat(v.quantity)
            : parseInt(v.quantity);

          return {
            ...v,
            quantity,
            freebies: v.freebies?.map((fb: any) => {
              const quantity = !Number.isInteger(parseFloat(fb.quantity))
                ? parseFloat(fb.quantity)
                : parseInt(fb.quantity);
              return { ...fb, quantity, product: undefined };
            }),
          };
        });
        return {
          productId,
          productName,
          productCategory,
          productImage,
          packsize: packSize,
          condition,
        };
      });
    } else if (promotionType === PromotionType.DISCOUNT_NOT_MIX) {
      let productListData = productList?.allData || [];
      if (!productList?.allData?.length) {
        productListData = await fetchProductList();
      }
      submitData.conditionDetailDiscount = Object.entries(promoList).map(([key, value]) => {
        const conditionValue = (value as any).map((v: any, i: number) => {
          const quantity = !Number.isInteger(parseFloat(v.quantity))
            ? parseFloat(v.quantity)
            : parseInt(v.quantity);
          const discountPrice = !Number.isInteger(parseFloat(v.discountPrice))
            ? parseFloat(v.discountPrice)
            : parseInt(v.discountPrice);

          return {
            ...v,
            quantity,
            discountPrice,
          };
        });
        const [pKey, productId] = key.split("-");
        const { productName, productCategory, productImage, packSize } =
          productListData?.find((p: ProductEntity) => p.productId === productId) ||
          defaultData?.conditionDetail?.find((p: any) => p.productId === productId) ||
          ({} as ProductEntity);

        return {
          productId,
          productName,
          productCategory,
          productImage,
          packsize: packSize,
          condition: conditionValue,
        };
      });
    } else if (promotionType === PromotionType.FREEBIES_MIX) {
      if (promoStateValue.promotionGroupOption === PromotionGroupOption.UNIT) {
        submitData.conditionDetailDiscount = undefined;
        submitData.conditionMixFreebies = Object.entries(promoList).map(
          ([key, condition]: any[]) => {
            const conditionFreebies = condition.map((v: any) => {
              const quantity = !Number.isInteger(parseFloat(v.quantity))
                ? parseFloat(v.quantity)
                : parseInt(v.quantity);
              return {
                ...v,
                quantity,
                freebies: v.freebies?.map((fb: any) => {
                  const quantity = !Number.isInteger(parseFloat(fb.quantity))
                    ? parseFloat(fb.quantity)
                    : parseInt(fb.quantity);
                  return { ...fb, quantity, product: undefined };
                }),
              };
            });
            return {
              products: promoStateValue.productGroup
                .filter((item: ProductEntity) => item.groupKey && `${item.groupKey}` === `${key}`)
                .map((item: ProductEntity) => ({
                  ...item,
                })),
              typeMix: promoStateValue.promotionGroupOption
                ? promoStateValue.promotionGroupOption
                : PromotionGroupOption.UNIT,
              conditionFreebies,
            };
          },
        );
      } else {
        const weightList: any = {};
        submitData.conditionDetailDiscount = undefined;
        submitData.conditionMixFreebies = Object.entries(promoList)
          .filter(([fullKey, value]) => {
            const [key, isWeight] = fullKey.split("-");
            if (isWeight) weightList[key] = value;
            return !isWeight;
          })
          .map(([key, condition]: any[]) => {
            const conditionFreebies = condition.map((v: any) => {
              return {
                ...v,
                freebies: v.freebies?.map((fb: any) => {
                  const mapFbQuantity = !Number.isInteger(parseFloat(fb.quantity))
                    ? parseFloat(fb.quantity)
                    : parseInt(fb.quantity);
                  return { ...fb, quantity: mapFbQuantity, product: undefined };
                }),
              };
            });
            const mapSize = !Number.isInteger(parseFloat(weightList[key]))
              ? parseFloat(weightList[key])
              : parseInt(weightList[key]);
            return {
              typeMix: promoStateValue.promotionGroupOption
                ? promoStateValue.promotionGroupOption
                : PromotionGroupOption.UNIT,
              size: mapSize,
              products: promoStateValue.productGroup
                .filter((item: ProductEntity) => item.groupKey && `${item.groupKey}` === `${key}`)
                .map((item: ProductEntity) => ({
                  ...item,
                  typeMix: promoStateValue.promotionGroupOption
                    ? promoStateValue.promotionGroupOption
                    : PromotionGroupOption.UNIT,
                })),
              conditionFreebies,
            };
          });
      }
    } else if (promotionType === PromotionType.DISCOUNT_MIX) {
      submitData.conditionDetailDiscount = undefined;
      if (promoStateValue.promotionGroupOption !== PromotionGroupOption.WEIGHT) {
        submitData.conditionMixDiscount = Object.entries(promoList).map(
          ([key, conditionDiscount]) => {
            const conditionValue = (conditionDiscount as any).map((v: any, i: number) => {
              const quantity = !Number.isInteger(parseFloat(v.quantity))
                ? parseFloat(v.quantity)
                : parseInt(v.quantity);
              const discountPrice = !Number.isInteger(parseFloat(v.discountPrice))
                ? parseFloat(v.discountPrice)
                : parseInt(v.discountPrice);

              return {
                ...v,
                quantity,
                discountPrice,
              };
            });
            return {
              products: promoStateValue.productGroup
                .filter((item: ProductEntity) => item.groupKey && `${item.groupKey}` === `${key}`)
                .map((item: ProductEntity) => ({
                  ...item,
                  typeMix: promoStateValue.promotionGroupOption
                    ? promoStateValue.promotionGroupOption
                    : PromotionGroupOption.UNIT,
                })),
              conditionDiscount: conditionValue,
              typeMix: promoStateValue.promotionGroupOption
                ? promoStateValue.promotionGroupOption
                : PromotionGroupOption.UNIT,
            };
          },
        );
      } else {
        setCreating(false);
        const groups: any = {};
        Object.entries(promoList).forEach(([fullKey, val]: any) => {
          const [groupKey, productId] = fullKey.split("-");
          let mapProduct: any = {};
          if (productId !== "weight") {
            mapProduct = { ...val, productId };
          }
          groups[groupKey] = {
            typeMix: "Size",
            products: [
              ...(mapProduct ? [mapProduct] : []),
              ...(groups[groupKey]?.products || []),
            ].filter((p: any) => p.productId && !p.productId.includes("weight")),
            size: productId === "weight" ? val : groups[groupKey]?.size || 0,
          };
        });

        submitData.conditionMixDiscount = Object.entries(groups).map(
          ([key, conditionDiscount]: any) => {
            const mapDiscountPrice = promoStateValue.productGroup.map((v: any) => {
              const findDiscountPrice = conditionDiscount.products?.find(
                (p: any) => p.productId === v.productId,
              );
              const discountPrice = !Number.isInteger(parseFloat(findDiscountPrice?.discountPrice))
                ? parseFloat(findDiscountPrice?.discountPrice)
                : parseInt(findDiscountPrice?.discountPrice);

              const mapSize = !Number.isInteger(parseFloat(conditionDiscount?.size))
                ? parseFloat(conditionDiscount?.size)
                : parseInt(conditionDiscount?.size);

              return {
                ...v,
                saleUnit: findDiscountPrice?.saleUnitDiscount,
                saleUnitDiscount: findDiscountPrice?.saleUnitDiscount,
                discountPrice: findDiscountPrice ? discountPrice : v.discountPrice,
                size: findDiscountPrice ? mapSize : v.size,
              };
            });
            const mapSizeInProd = mapDiscountPrice
              .filter((item: ProductEntity) => item.groupKey && `${item.groupKey}` === `${key}`)
              .map((prod: any) => {
                const mapSize = !Number.isInteger(parseFloat(prod.size))
                  ? parseFloat(prod.size)
                  : parseInt(prod.size);

                return {
                  ...prod,
                  size: mapSize,
                  typeMix: promoStateValue.promotionGroupOption
                    ? promoStateValue.promotionGroupOption
                    : PromotionGroupOption.UNIT,
                };
              });
            const mapConditionDiscount: any = {
              size: mapSizeInProd[0].size,
              products: mapSizeInProd,
              typeMix: promoStateValue.promotionGroupOption
                ? promoStateValue.promotionGroupOption
                : PromotionGroupOption.UNIT,
            };

            return {
              size: mapSizeInProd[0].size,
              products: mapSizeInProd,
              conditionDiscount: mapConditionDiscount,
            };
          },
        );
      }
    } else if (promotionType === PromotionType.DISCOUNT_NOT_MIX_SET) {
      let productListData = productList?.allData || [];
      if (!productList?.allData?.length) {
        productListData = await fetchProductList();
      }
      submitData.conditionDetailDiscount = Object.entries(promoList).map(([key, value]) => {
        const conditionValue = value as any;
        [0];
        if (!Number.isInteger(parseFloat(conditionValue.quantity))) {
          conditionValue.quantity = parseFloat(conditionValue.quantity);
        } else {
          conditionValue.quantity = parseInt(conditionValue.quantity);
        }
        if (!Number.isInteger(parseFloat(conditionValue.discountPrice))) {
          conditionValue.discountPrice = parseFloat(conditionValue.discountPrice);
        } else {
          conditionValue.discountPrice = parseInt(conditionValue.discountPrice);
        }
        const [pKey, productId] = key.split("-");
        const { productName, productCategory, productImage, packSize } =
          productListData?.find((p: ProductEntity) => p.productId === productId) ||
          defaultData?.conditionDetail?.find((p: any) => p.productId === productId) ||
          ({} as ProductEntity);

        return {
          productId,
          productName,
          productCategory,
          productImage,
          packsize: packSize,
          condition: conditionValue,
        };
      });
    } else if (promotionType === PromotionType.DISCOUNT_MIX_RANGE) {
      const groups: any = {};
      Object.entries(promoList).forEach(([fullKey, val]: any) => {
        const [groupKey, productId] = fullKey.split("-");
        groups[groupKey] = {
          min: fullKey.includes("min") ? val : groups[groupKey]?.min || 0,
          max: fullKey.includes("max") ? val : groups[groupKey]?.max || 0,
          products: [...(groups[groupKey]?.products || []), { ...val, productId }].filter(
            (p: any) => p.productId && !p.productId.includes("min") && !p.productId.includes("max"),
          ),
        };
      });
      submitData.conditionMixDiscount = Object.entries(groups).map(
        ([key, conditionDiscount]: any) => {
          const mapCondition: any = {
            min: Number(parseFloat(conditionDiscount.min))
              ? parseFloat(conditionDiscount.min)
              : parseInt(conditionDiscount.min),
            max: Number(parseFloat(conditionDiscount.max))
              ? parseFloat(conditionDiscount.max)
              : parseInt(conditionDiscount.max),
            products: (conditionDiscount as any).products.map((v: any) => {
              const quantity = !Number.isInteger(parseFloat(v.quantity))
                ? parseFloat(v.quantity)
                : parseInt(v.quantity);
              const discountPrice = !Number.isInteger(parseFloat(v.discountPrice))
                ? parseFloat(v.discountPrice)
                : parseInt(v.discountPrice);

              return {
                ...v,
                quantity,
                discountPrice,
              };
            }),
          };

          return {
            products: promoStateValue.productGroup
              .filter((item: ProductEntity) => item.groupKey && `${item.groupKey}` === `${key}`)
              .map((item: ProductEntity) => ({
                ...item,
                typeMix: promoStateValue.promotionGroupOption
                  ? promoStateValue.promotionGroupOption
                  : PromotionGroupOption.UNIT,
              })),
            conditionDiscount: mapCondition,
          };
        },
      );
    } else if (promotionType === PromotionType.OTHER) {
      submitData.conditionDetailDiscount = undefined;
      submitData.isQuotaAll = false;
      submitData.isQuotaShop = false;
      submitData.stores = stores?.map((s) => ({ ...s, quotaReceive: undefined }));
      submitData.conditionOther = Object.entries(promoList).map(([key, values]) => {
        const { detail } = (values as any[])[0];
        return {
          products: promoStateValue.productGroup
            .filter((item: ProductEntity) => item.groupKey && `${item.groupKey}` === `${key}`)
            .map((item: ProductEntity) => ({
              ...item,
              typeMix: promoStateValue.promotionGroupOption
                ? promoStateValue.promotionGroupOption
                : PromotionGroupOption.UNIT,
            })),
          detail,
        };
      });
    }
    const callback = (res: any) => {
      const { success, responseData, developerMessage, userMessage } = res;
      const promotionId = responseData?.promotionId || id;
      const hasFile = file1 || file2 || fileMemo;
      const onDone = () => {
        form1.resetFields();
        form2.resetFields();
        form3.resetFields();
        setDone(true);
        setTimeout(() => {
          navigate("/PromotionPage/promotion");
          // navigate(1);
          window.location.reload();
        }, 2000);
        setTimeout(() => {
          setDone(false);
        }, 2000);
      };

      if (success) {
        if (!hasFile && fileEditHistory.size <= 0) {
          onDone();
        } else {
          const formData = new FormData();
          formData.append("promotionId", promotionId);
          if (fileEditHistory.has(fileKeys.IMAGE1)) {
            formData.append("promotionImageFirstCheck", "true");
            formData.append("promotionImageFirst", file1);
          }
          if (fileEditHistory.has(fileKeys.IMAGE2)) {
            formData.append("promotionImageSecondCheck", "true");
            formData.append("promotionImageSecond", file2);
          }
          if (fileEditHistory.has(fileKeys.MEMO)) {
            formData.append("fileMemoCheck", "true");
            formData.append("fileMemo", fileMemo?.originFileObj);
          }
          updatePromotionFile(formData)
            .then((res) => {
              onDone();
            })
            .catch((err) => {
              console.log("updatePromotionFile", err);
              throw err;
            });
        }
      } else {
        message.error(userMessage || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    };
    setCreating(false);
    if (!isEditing) {
      await createPromotion(submitData)
        .then(callback)
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setCreating(false);
        });
    } else {
      await updatePromotion(submitData)
        .then(callback)
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setCreating(false);
        });
    }
  };

  return (
    <>
      {
        <CardContainer>
          <PageTitle />
          <Divider />
          {stepsComponents[step]}
          <Divider />
          <Row justify='space-between' gutter={12}>
            <Col xl={3} sm={6}>
              {step > 0 && (
                <Button
                  typeButton='primary-light'
                  title='ย้อนกลับ'
                  onClick={() => setStep(step - 1)}
                />
              )}
            </Col>
            <Col xl={15} sm={6}></Col>
            {/* <Col xl={3} sm={6}>
                {(!isEditing || defaultData?.isDraft) && (
                  <Button
                    typeButton='primary-light'
                    title='บันทึกแบบร่าง'
                    disabled={isCreating}
                    onClick={onSaveDraft}
                  />
                )}
              </Col> */}
            <Col xl={3} sm={6}>
              <Button
                typeButton='primary'
                title={step === 2 ? "บันทึก" : "ถัดไป"}
                onClick={onNext}
                disabled={isCreating}
              />
            </Col>
          </Row>
        </CardContainer>
      }
      <Modal open={isCreating || isDone} footer={null} width={220} closable={false}>
        <FlexCol align='center' justify='center' style={{ width: 172, height: 172 }}>
          {isDone ? (
            <CheckCircleTwoTone twoToneColor={color.success} style={{ fontSize: 36 }} />
          ) : (
            <Spin size='large' />
          )}
          <br />
          <Text level={4} align='center'>
            {isDone ? (
              <>
                {isEditing ? "แก้ไข" : "สร้าง"}โปรโมชัน
                <br />
                สำเร็จ
              </>
            ) : (
              <>
                กำลัง{isEditing ? "แก้ไข" : "สร้าง"}
                <br />
                โปรโมชัน
              </>
            )}
          </Text>
        </FlexCol>
      </Modal>
    </>
  );
};
